import { render } from "./FeedbackFormLayout.vue?vue&type=template&id=31f42986&scoped=true&ts=true"
import script from "./FeedbackFormLayout.vue?vue&type=script&lang=ts"
export * from "./FeedbackFormLayout.vue?vue&type=script&lang=ts"

import "./FeedbackFormLayout.vue?vue&type=style&index=0&id=31f42986&scoped=true&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f42986"]])

export default __exports__